import { ILocalStorage } from '../storage/interfaces';
import { StorageKeys } from '../../utils/constants';
import { CreateTableSettings, ITableSettingsService } from './interfaces';
import { BehaviorSubject } from 'rxjs';

export default class TableSettingsService implements ITableSettingsService {
  settings: BehaviorSubject<CreateTableSettings>;

  constructor(private persistentStorage: ILocalStorage, private DEFAULT_SETTINGS: CreateTableSettings) {
    const savedOptions = this.persistentStorage.get(StorageKeys.CREATE_TABLE_OPTIONS);
    const newOptions = { ...this.DEFAULT_SETTINGS, ...savedOptions };
    this.settings = new BehaviorSubject(newOptions);
    this.setTableOptions(JSON.stringify(newOptions));
  }

  setTableOptions(data: string): void {
    const newCreateTableOptions = JSON.parse(data);
    this.persistentStorage.set(StorageKeys.CREATE_TABLE_OPTIONS, newCreateTableOptions);
    this.settings.next(newCreateTableOptions);
  }

  changeCreateTableOptions(key: keyof CreateTableSettings, value: any) {
    const prevCreateTableOptions = this.persistentStorage.get(StorageKeys.CREATE_TABLE_OPTIONS);
    const newCreateTableOptions = { ...prevCreateTableOptions, [key]: value };
    this.persistentStorage.set(StorageKeys.CREATE_TABLE_OPTIONS, newCreateTableOptions);
    this.settings.next(newCreateTableOptions);
  }

  getCreateTableSettings(): CreateTableSettings {
    return this.settings.value;
  }
}
